<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-20 md-size-25 md-small-size-0">
			</div>
			<div class="md-layout-item md-medium-size-60 md-size-50 md-small-size-100">

				<md-card>
					<md-card-header data-background-color="purple">

						<h4 class="title"><b>{{$store.state.locale.locale.registration[$store.state.locale.lang]}}</b></h4>
					</md-card-header>
					<md-card-content>
						<router-view />
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Registration.vue